export default {
	tenantId: "omsa_uat",
	appId: "covergo_crm",
	fileSystem: {
		bucketName: "omsa--uat"
	}
}
